import { render } from "./AppRequests.vue?vue&type=template&id=4ed629f2"
import script from "./AppRequests.vue?vue&type=script&lang=js"
export * from "./AppRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__